export default __webpack_public_path__ + "static/media/Shape.72fe345d.svg";